<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },

  components: {

  },

  methods: {

  }
}
</script>

<style>
 a {
   text-decoration: none;
   color: #4399e8;
 }

 span {
   display: inline-block;
 }

 /*重写vue-directive-image-previewer/dist/assets/style.css 的类，将z-index:999，以便预览的图像置在顶层*/
 .vue-directive-image-previewer-body {
   width:100%;
   height:100%;
   z-index:999
 }
 .vue-directive-image-previewer-body img {
   position:absolute;
   z-index:999
 }

 .path {
   height: 40px;
   line-height: 40px;
   padding-left: 16px;
   font-size: 14px;
   color: #666;
 }

 .my-table {
   width:1250px;
   font-size: 15px;
   color: #555;
 }

 .table-header {
   font-weight: bold;
 }

 .table-cell {
   /*border-right: 1px solid black;*/
   line-height: 48px;
   text-align: left;
   font-size: 14px;
 }

 .table-row:hover {
   background-color: #fcf5e8;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue